import React from 'react';
import { Card } from 'react-bootstrap';
import NumberFormat from 'react-number-format';

// https://www.npmjs.com/package/react-d3-speedometer
// https://nivo.rocks/pie/

interface CotaFaturamento {
	supervisorId: number;
	representativeId: number;
	quotaArticle: number;
	month: number;
	year: number;
	goal: number;
	revenues: number;
}

interface Props {
	cotaFaturamento: CotaFaturamento;
}

const Revenue = ({ cotaFaturamento }: Props) => {
	return (
		<div className="div-indicador">
			{/* @ts-ignore */}
			<Card>
				{/* @ts-ignore */}
				<Card.Header style={{ fontWeight: 'bold' }}>
					Faturamento do Mês
				</Card.Header>
				{/* @ts-ignore */}
				<Card.Body>
					<div className="revenue">
						<NumberFormat
							displayType="text"
							thousandSeparator="."
							decimalSeparator=","
							prefix={'R$'}
							decimalScale={2}
							fixedDecimalScale
							value={cotaFaturamento?.revenues ?? 0}
						/>
					</div>
				</Card.Body>
			</Card>
		</div>
	);
};

export default Revenue;
